var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWarningInfoIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 12.5C0 5.59644 5.59644 0 12.5 0C19.4036 0 25 5.59644 25 12.5C25 19.4036 19.4036 25 12.5 25C5.59644 25 0 19.4036 0 12.5ZM12.5 1.74419C6.55973 1.74419 1.74419 6.55973 1.74419 12.5C1.74419 18.4402 6.55973 23.2558 12.5 23.2558C18.4402 23.2558 23.2558 18.4402 23.2558 12.5C23.2558 6.55973 18.4402 1.74419 12.5 1.74419Z",
    fill: "#FF6666"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.1626 18.5002C12.6442 18.5002 13.0347 18.1098 13.0347 17.6281V10.6514C13.0347 10.1698 12.6442 9.7793 12.1626 9.7793C11.681 9.7793 11.2905 10.1698 11.2905 10.6514V17.6281C11.2905 18.1098 11.681 18.5002 12.1626 18.5002Z",
    fill: "#FF6666"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.1628 6C12.805 6 13.3256 6.5206 13.3256 7.16279C13.3256 7.80498 12.805 8.32558 12.1628 8.32558C11.5206 8.32558 11 7.80498 11 7.16279C11 6.5206 11.5206 6 12.1628 6Z",
    fill: "#FF6666"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningInfoIcon);
export default __webpack_public_path__ + "static/media/WarningInfoIcon.2ae53958ee274352a399c077b65372b3.svg";
export { ForwardRef as ReactComponent };